export default function(rootElement, swipeNavButton) {
  if (!rootElement || !swipeNavButton) {
    return;
  }

  function remove(event) {
    rootElement.onscroll = null;
    rootElement.removeChild(swipeNavButton);
    if (event.target === swipeNavButton) {
      rootElement.scrollLeft = rootElement.offsetWidth;
    }
  }

  swipeNavButton.onclick = remove;
  rootElement.onscroll = remove;

  if ((rootElement.scrollWidth - rootElement.offsetWidth) > 0) {
    rootElement.insertAdjacentHTML('beforeend', `<style>@media all and (max-width:${rootElement.scrollWidth}px){
      .${rootElement.className.split(' ').join('.')} [data-role="nav-swipe-button"] {display: block}
    }</style>`);
  }
}
